import axios from 'axios';

const API_URL = window.config.API_URL; 
const MESSAGES_URL = window.config.messagesUrl; 

export const login = (usuario, password) => {
  return axios.post(`${API_URL}/Account/Login`, {usuario, password});
}

export const reloadToken = (url, token) => {
  return axios.post(`${API_URL}/Account/ReLogin`, {}, {headers: {Authorization : token}});
}

export const MenuSSO = (token) => {
  return axios.get(`${API_URL}/FeatureAccess/menu`, {headers: {Authorization : token}});
}

export const getMessagesCount = (url, token) => {
  return axios.get(url, {headers : {Authorization : token}});
}

const AbmApiBase = (controller, token, cancelToken) => {

  const createAxiosConfig = (token) => {
    return {headers: {Authorization: token}, cancelToken};
  }

  const schema = (section) => {
    return axios.get(`${API_URL}/Abm/${controller}${section ? `/${section}` : ``}/schema`, createAxiosConfig(token));
  }

  const index = (page = 1, pageSize = 15) => {
    return axios.get(`${API_URL}/Abm/${controller}/${page}/${pageSize}`, createAxiosConfig(token));
  }
  
  const filter = (term = "") => {
    return axios.get(`${API_URL}/Abm/filter/${controller}/${term}`, createAxiosConfig(token));
  }

  const editForm = (id) => {
    return axios.get(`${API_URL}/Abm/getItem/${controller}/${id}`, createAxiosConfig(token));
  }
  
  const editItem = (id, data, section) => {
    return axios.put(`${API_URL}/Abm/${controller}${section ? `/${section}` : ``}`, {body: JSON.stringify(data)}, createAxiosConfig(token));
  }
  
  const addForm = () => {
    return axios.get(`${API_URL}/Abm/getItem/${controller}/`, createAxiosConfig(token));
  }
  
  const addItem = (data, section) => {
    return axios.post(`${API_URL}/Abm/${controller}${section ? `/${section}` : ``}`, {body: JSON.stringify(data)}, createAxiosConfig(token));
  }
  
  const removeItem = (data, section) => {
    return axios.post(`${API_URL}/Abm/delete/${controller}${section ? `/${section}` : ``}`, {body: JSON.stringify(data)}, createAxiosConfig(token));
  }
  
  const getTable = (id) => {
    return axios.get(`${API_URL}/Abm/selectList/${id}`, createAxiosConfig(token));
  }
  
  const getTimeline = (id) => {
    return axios.get(`${API_URL}/Abm/${controller}/${id}/getTimeline`, createAxiosConfig(token));
  }
  
  const getEnum = (campo, tabla) => {
    return axios.get(`${API_URL}/Abm/getEnum/${tabla || controller}/${campo}`, createAxiosConfig(token));
  }

  const keyValueStore = (data) => {
    return axios.post(`${API_URL}/Abm/keyValue`, {body: data}, createAxiosConfig(token));
  }

  const keyValueCreate = (key, data) => {
    return axios.post(`${API_URL}/Abm/keyValue/${key}`, {body: data}, createAxiosConfig(token));
  }
  
  const keyValueUpdate = (key, data) => {
    return axios.put(`${API_URL}/Abm/keyValue/${key}`, {body: data}, createAxiosConfig(token));
  }

  const keyValueDelete = (key) => {
    return axios.delete(`${API_URL}/Abm/keyValue/${key}`, createAxiosConfig(token));
  }

  const keyValueGet = (key) => {
    return axios.get(`${API_URL}/Abm/keyValue/${key}`, createAxiosConfig(token));
  }

  const getNodeTypes = () => {
    return axios.get(`${API_URL}/Abm/getNodeTypes/`, createAxiosConfig(token));
  }

  const getFlow = (idOperacion) => {
    return axios.get(`${API_URL}/Abm/flow/${idOperacion}`, createAxiosConfig(token));
  }

  const getFlowOutputs = (data) => {
    return axios.post(`${API_URL}/Abm/flow/outputs`, {body: JSON.stringify(data)}, createAxiosConfig(token));
  }
  
  const postFlow = (idOperacion, data) => {
    return axios.post(`${API_URL}/Abm/flow/${idOperacion}`, {body: JSON.stringify(data)}, createAxiosConfig(token));
  }

  const getConectionTypes = () => {
    return axios.get(`${API_URL}/Abm/getConectionTypes`, createAxiosConfig(token));
  }

  return {index, editForm, editItem, addForm, addItem, removeItem, getTable, getTimeline, getEnum, filter, schema, keyValueStore, keyValueCreate, keyValueUpdate, keyValueDelete, keyValueGet, getNodeTypes, getFlow, getConectionTypes, postFlow, getFlowOutputs};
}

export const callActionDialog = (action, token, timeout) => {
  return axios.post(`${API_URL}/Abm/callAction`, {action}, {headers: {Authorization: token}});
}

export const useAbmApi = (controller, getState) => AbmApiBase(controller, getState().auth.token);

export const useAbmApi2 = (controller) => {
  const init = (getState) => {
    return AbmApiBase(controller, getState().auth.token);
  }
  return init;
}

export const useAbmApiWithCancelToken = (controller) => {
  const source = axios.CancelToken.source();
  const { token, cancel } = source;
  const init = (getState) => {
    return AbmApiBase(controller, getState().auth.token, token);
  }
  return {init, cancel};
}